import { defineComponent } from "@vue/composition-api";
import SectionTitle from "@Client/@Modules/application-standalone/components/helpers/section-title.vue";
export default defineComponent({
  name: "PageSummarySectionGroupLayout",
  components: {
    SectionTitle
  },
  props: {
    showDivider: {
      type: Boolean,
      default: false
    }
  },
  setup() {}
});